/* eslint-disable no-unused-vars */

/**
 * Accordion
 * To create accordion - element needs a 'js-collapse'' class and 'data-target' attribute
 * pointing to target element.
 */

import { debounce } from './shared';

$(document).ready(function () {
  $(window).trigger('resize');
});

$(window).on(
  'resize',
  debounce(function (event) {
    calculateAccordionHeights();
  }, 200)
);

$('.js-collapse').on('click', function () {
  // don't do anything if data-target attribute is not present
  if ($(this).data('target') == null) {
    return false;
  }

  var target = $('body').find($(this).data('target'));
  if (target != null) {
    target.toggleClass('collapsed');
    target.closest('.accordion-item').toggleClass('accordion-item--open');
  }
});

function calculateAccordionHeights() {
  $('.js-collapse-target').each(function () {
    $(this).css(
      'max-height',
      $(this).find('.accordion-item__body-inner').innerHeight()
    );
  });
}
